// extracted by mini-css-extract-plugin
export default {"root":"big2ZD","responsive-root":"SHHiV9","responsiveRoot":"SHHiV9"};